import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import UnderlinedText from '../UnderlinedText';

import { updateView } from 'actions';
import { track } from 'utils/analytics';
import { isMobilePortrait } from 'utils/device';

import './index.css';

class Splash extends Component {
	constructor(props) {
		super(props);

		this.state = {
			transition: null,
			justify: 'bottom'
		};

		this.handleResize = this.handleResize.bind(this);
		this.handleCtaClick = this.handleCtaClick.bind(this);
		this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
	}

	handleResize() {
		const minHeight = window.innerHeight - 60;
		let height = this.splash.childNodes[0].getBoundingClientRect().height;

		console.log(height, minHeight);

		const justify = height > minHeight ? 'start' : 'center';
		this.setState(() => ({ justify }));
	}

	handleAnimationEnd(e) {
		const { dispatch } = this.props;
		const { transition } = this.state;
		if (transition === 'out' && e.target.classList.contains('last')) {
			setTimeout(() => dispatch(updateView('quiz')), 250);
		}
	}

	handleCtaClick() {
		this.setState(() => ({
			transition: 'out'
		}));

		track('clicked', 'get started');
	}

	handleTargetLogoClickout(url) {
		window.open(url, '_blank');
		track('clicked', 'target logo');
	}

	componentWillReceiveProps(nextProps) {
		const { view: { id } } = this.props;
		if (id !== 'splash' && nextProps.view.id === 'splash') {
			this.setState(() => ({
				transition: 'in'
			}));
		} 
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	componentDidMount() {
		const { view: { id } } = this.props;
		if (id === 'splash') {
			this.setState(() => ({
				transition: 'in'
			}));
		}

		track('visible', 'intro');
		window.addEventListener('resize', this.handleResize);

		// setTimeout(() => this.handleCtaClick(), 500);
		// alert(window.innerHeight);
	}

	render() {
		const {
			view,
			introbackgroundImage,
			introBackgroundImageMobileUrl,
			introSiteTitle,
			introdescriptionCopy,
			introtextColorHex,
			introCoBrandLogo,
			beautyBondClickOutUrl } = this.props;
		const { transition, justify } = this.state;
		const children = introSiteTitle.split(/\n/g);

		return (
			<div className={`splash content view ${view.id === 'splash' ? 'active' : ''} ${transition} ${justify}`} style={{backgroundImage: `url(${isMobilePortrait() ? introBackgroundImageMobileUrl : introbackgroundImage})`}} ref={instance => this.splash = instance}>
				<div className="lockup left">
					<div className="hero" style={{color: introtextColorHex}}>
						{children.map((line, i) => <UnderlinedText text={line} colour={'#00ffff'} className={`animate-line animated ${i === children.length - 1 ? 'last' : ''}`} onAnimationStart={i === children.length - 1 ? this.handleAnimationEnd : null} key={`splash-line-${i}`} />)}
					</div>
					<img className="logo animated" src={introCoBrandLogo} onClick={() => this.handleTargetLogoClickout(beautyBondClickOutUrl)} alt="co-branded logo" />
					<div className="body animated">
					{introdescriptionCopy}
					</div>
					<div className="cta-wrapper animated">
						<div className="cta" onClick={this.handleCtaClick}>Get Started!</div>
					</div>
				</div>
				<div className="lockup right animated" ref={instance => this.right = instance}>
					<img src={`./intro.main.${isMobilePortrait() ? 'mobile' : 'desktop'}.jpg`} className="main" />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	view: state.view,
	question: state.question
});

Splash = connect(mapStateToProps)(Splash);
export default Splash;



// WEBPACK FOOTER //
// ./src/components/Splash/index.js